import { Globe, Upload, Filter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { formatDistanceToNow } from "date-fns";

export default function BrowserHistory() {
  // todo: remove mock functionality
  const historyItems = [
    {
      id: "1",
      url: "https://arxiv.org/abs/1706.03762",
      title: "Attention Is All You Need - Research Paper",
      visitedAt: new Date(Date.now() - 1000 * 60 * 30),
      category: "Research",
      imported: false,
    },
    {
      id: "2",
      url: "https://react.dev/blog/2023/03/22/react-labs-what-we-have-been-working-on-march-2023",
      title: "React Labs: What We've Been Working On",
      visitedAt: new Date(Date.now() - 1000 * 60 * 60 * 2),
      category: "Development",
      imported: true,
    },
    {
      id: "3",
      url: "https://www.perplexity.ai/search/machine-learning-basics",
      title: "Machine Learning Basics - Perplexity Search",
      visitedAt: new Date(Date.now() - 1000 * 60 * 60 * 5),
      category: "Learning",
      imported: false,
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold mb-2">Browser History Integration</h1>
          <p className="text-muted-foreground">Import browsing history as reference material</p>
        </div>
        <Button data-testid="button-sync-history">
          <Upload className="h-4 w-4 mr-2" />
          Sync History
        </Button>
      </div>

      <Card className="p-6 bg-accent/50">
        <div className="flex items-start gap-3">
          <Globe className="h-5 w-5 text-primary mt-1" />
          <div>
            <h3 className="font-semibold mb-1">How it works</h3>
            <p className="text-sm text-muted-foreground mb-3">
              Connect your browser to automatically import visited pages. We'll analyze and categorize them to enrich your knowledge base.
            </p>
            <Button variant="outline" size="sm" data-testid="button-install-extension">
              Install Browser Extension
            </Button>
          </div>
        </div>
      </Card>

      <div className="flex gap-4">
        <Input
          placeholder="Filter by URL or title..."
          className="flex-1"
          data-testid="input-filter-history"
        />
        <Button variant="outline" data-testid="button-filter">
          <Filter className="h-4 w-4 mr-2" />
          Filter
        </Button>
      </div>

      <div className="space-y-3">
        {historyItems.map((item) => (
          <Card key={item.id} className="p-4 hover-elevate transition-all" data-testid={`history-${item.id}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <h3 className="font-medium mb-1 truncate">{item.title}</h3>
                <p className="text-sm text-muted-foreground truncate mb-2">{item.url}</p>
                <div className="flex items-center gap-2">
                  <Badge variant="secondary" className="text-xs">{item.category}</Badge>
                  <span className="text-xs text-muted-foreground">
                    {formatDistanceToNow(item.visitedAt, { addSuffix: true })}
                  </span>
                </div>
              </div>
              <Button
                variant={item.imported ? "secondary" : "default"}
                size="sm"
                disabled={item.imported}
                data-testid={`button-import-${item.id}`}
              >
                {item.imported ? "Imported" : "Import"}
              </Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
